import { createRouter, RouterProvider } from '@tanstack/react-router';
import { routeTree } from '@/routeTree.gen';
import { subscribeRouterToAnalytics } from '@/shared/lib/analytics';

export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

subscribeRouterToAnalytics(router);

export const AppRouter = () => <RouterProvider router={router} />;
